
<template>
   <div>
      <Guci-years :listYear="listYear" :listDate="listDate"></Guci-years>

      <div style="display: flex; justify-content: space-between; line-height:40px; ">
         <div style=" display: flex; padding-left: 40px; width: 500px;">
         <h3>切换部门 ：</h3>
          <el-select v-model="groupNameValue" placeholder="请选择" style="margin-top: 20px;">
            <el-option
               v-for="item in depList"
               :key="item.id"
               @click.native="clickGroupPersonList(item.groupId)"
               :label="item.groupName"
               :value="item.groupName"
             >
            </el-option>
         </el-select>
      </div>
      <div style="display: flex; margin-right: 50px; margin-top: 20px">
         <div><button style="border: none; background-color: #1683dc; height: 40px; color: #ffff;border-radius: 5px;margin-right: 20px" @click="getAttendanceGroup()">同步考勤组数据</button></div>
      <div><button  style="border: none; background-color: #1683dc; height: 40px; color: #ffff;border-radius: 5px" @click="getAttendanceUser()">同步考勤组人员数据</button></div>
      </div>
      </div>
      <Guci-personnelInfo  :dataList="dataList" :depName="groupNameValue"></Guci-personnelInfo>
      
   </div>
</template>

<script>

import axios from "axios";
import apiBaseUrl from "../../config/api";
import loadingUtils from "../utils/loading";
import { put, signatureUrl, getFileNameUUID } from "../utils/oss";
import years from "./components/years";
import personnelInfo from "./components/personnelInfo";
import { getAttendanceGroupListAPI ,getGroupPersonListAPI,getAttendanceGroupAPI,getAttendanceUserAPI} from "@/api/Attendance.js"


export default {
    components:{ 'Guci-years': years, 'Guci-personnelInfo': personnelInfo,  },
    data() {
      return {
         listYear:['2016年','2017年','2018年','2019年','2020年','2021年','2022年','2023年','2024年','2025年','2026年','2027年','2028年','2029年','2030年','2031年','2032年'],
         listDate:['一月','二月','三月','四月','五月','六月','七月','八月','九月','十月','十一月','十二月'],
         dataList:[],
         depList:[],
         groupNameValue:'',
         depLisGroupName:'',
      };
    },

    created(){
      // this.getAttendanceGroupList()
    },

    mounted(){
      this.getAttendanceGroupList()
    },
    
    methods:{

      getAttendanceGroupList(){
         getAttendanceGroupListAPI().then(res =>{
            let { data } = res
            if(res.code === 200){
               this.depList = data
               this.groupNameValue = data[0].groupName
               this.clickGroupPersonList(data[0].groupId)

            }else{
               this.depList = []
               this.$message({ message: res.message,   type: "error"})
            }

         })
      },
      clickGroupPersonList(id){
         getGroupPersonListAPI(id).then(res =>{
         if(res.code === 200){
            this.dataList = res.data
         }else{
            this.$message({ message: res.message,   type: "error"})
         }
      })
      },
      getAttendanceGroup(){
         getAttendanceGroupAPI().then(res=>{
            console.log(res);
            if(res.code === 200){
               this.getAttendanceGroupList()
               this.$message({type: 'success', message: '查询成功'})
            }else{
               this.$message({ message: res.message,   type: "error"})
            }
            })
      },
      getAttendanceUser(){
         getAttendanceUserAPI().then(res=>{
            console.log(res);
            if(res.code === 200){
               this.getAttendanceGroupList()
               this.$message({type: 'success', message: '查询成功'})
            }else{
               this.$message({ message: res.message,   type: "error"})
            }
            })
      }
     
    }


    
};
</script>

<style scoped lang="less">
   

   .no-click {
      pointer-events: none;
    }
</style>
  


// WEBPACK FOOTER //
// src/AnonymousLetterManagement/AttendanceManagement.vue